// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineTabs_root__C1vFH","list":"MantineTabs_list__sk9HH","tab":"MantineTabs_tab__8bcxR","tabLabel":"MantineTabs_tabLabel__4NJ7e"};